import { useAuth } from '@workos-inc/authkit-react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { routes } from '~/constants/routes';
import { resetReduxStore } from '~/redux/actions/conversationPreview';
import { removeTokens } from '~/utils';

import { useSelectedChatbot } from './useSelectedChatbot';

type Options = {
  /**
   * If true, the logout process will not capture the current URL for returnTo redirection after login.
   */
  skipReturnTo?: boolean;
};

export const useLogout = ({ skipReturnTo = false }: Options = {}) => {
  const { signOut } = useAuth();
  const { selectedAgent } = useSelectedChatbot();
  const history = useHistory();
  const dispatch = useDispatch();

  const logout = async () => {
    let returnTo: string | null = null;
    if (!skipReturnTo) {
      const currentUrl = history.location.pathname + history.location.search;
      returnTo = currentUrl !== routes.signOut.path ? currentUrl : null;
    }

    removeTokens();
    window.sessionStorage.clear();
    dispatch(resetReduxStore());

    await signOut({
      returnTo: routes.signOut.get(selectedAgent!.id, { returnTo }),
      navigate: true,
    });
  };

  return logout;
};
